import classes from './MonthlyArticles.module.scss';
import ArticleCard from '../../organisms/articleCard/ArticleCard';

const MonthlyArticles = ({ data, ctaText }) => {
    const { title, articles } = data;

    let listToSort;

    if (articles?.data) listToSort = [...articles.data];
    else return null;

    return (
        <div className={classes.oThisMonth}>
            <div className={`${classes.oContainer} container`}>
                <h3 className={`${classes.aTitle} fntH3`}>{title}</h3>
                <div className={`row`}>
                    {listToSort
                        .sort((a, b) =>
                            a.attributes.display_date < b.attributes.display_date ? 1 : -1
                        )
                        .map((cardData) => (
                            <div
                                key={cardData.id}
                                className={`${classes.oCardColumn} col-12 col-md-6`}
                            >
                                <ArticleCard
                                    data={cardData}
                                    className={classes.mPinImage}
                                    ctaText={ctaText}
                                />
                            </div>
                        ))}
                </div>
            </div>
        </div>
    );
};

export default MonthlyArticles;
